import { useAppSelector } from 'application/providers/StoreProvider';
import { useAuthContext } from 'application/providers/AuthProvider';

export const useAccountInitializing = (): boolean => {
  const { hasAccess, userData } = useAuthContext();

  const isLoading = useAppSelector((state) => state.account.loading);
  const lastFetchTime = useAppSelector((state) => state.account.lastFetchTime);

  if (!hasAccess) return false;

  if (hasAccess && !userData?.id) return true;

  if (
    hasAccess &&
    userData?.id &&
    (userData?.companies === undefined || userData?.companies === null || userData?.companies.length === 0)
  )
    return false;

  if (hasAccess && userData?.id && !lastFetchTime) return true;

  if (isLoading && !lastFetchTime) return true;

  return false;
};
